import { Component, OnInit, Input } from '@angular/core';
import { NewsArticleSearchDto } from '../shared/dto/news-article-search.dto';

@Component({
  selector: 'wl-news-articles-search-params',
  templateUrl: './news-articles-search-params.component.html',
  styleUrls: ['./news-articles-search-params.component.less'],
    standalone: false
})
export class NewsArticlesSearchParamsComponent implements OnInit {
  @Input() searchParams: NewsArticleSearchDto;
  constructor() {}

  ngOnInit(): void {}
}
